var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('step-container',{attrs:{"academic-year":Number(_vm.$route.params.ay),"task-code":"PIM","title":"Perkins V Indicator Management","hide-step-status":_vm.hideStepStatus}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }